import React, {
  ReactNode,
  useRef,
  ComponentPropsWithoutRef,
  useLayoutEffect,
} from "react";
import { useDispatch } from "react-redux";
import { useElementDimensions } from "@sportal/cdk/hooks";

import { setHeaderHeight } from "../../../store/layout";

interface AppHeaderProps extends ComponentPropsWithoutRef<"header"> {
  children: ReactNode;
}

export const AppHeader = ({ children, ...attrs }: AppHeaderProps) => {
  const headerRef = useRef<HTMLElement>(null);
  const dispatch = useDispatch();
  const { height } = useElementDimensions(headerRef);

  useLayoutEffect(() => {
    dispatch(setHeaderHeight(height));
  }, [height, dispatch]);

  return (
    <header ref={headerRef} {...attrs}>
      {children}
    </header>
  );
};
